import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

// Remplace ces imports par tes vraies images ou utilise des URLs
import vendor1 from "./logo2/1.png";
import vendor2 from "./logo2/2.png";
import vendor3 from "./logo2/3.png";
import vendor4 from "./logo2/4.png";
import vendor5 from "./logo2/5.png";
import vendor6 from "./logo2/6.png";
import vendor7 from "./logo2/7.png";
import vendor8 from "./logo2/8.png";
import vendor9 from "./logo2/9.png";

const vendors = [
  vendor1, vendor2, vendor3, vendor4, vendor5, vendor6, vendor7, vendor8, vendor9,
];

const VendorCarousel = () => {
  const settings = {
  dots: false,
  infinite: true,
  speed: 3000,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: "linear",
  arrows: false,
  pauseOnHover: true,
  responsive: [
    
    { breakpoint: 992, settings: { slidesToShow: 4 } },
    { breakpoint: 768, settings: { slidesToShow: 3 } },
    { breakpoint: 576, settings: { slidesToShow: 2 } }
  ]
};

  return (
    <div className="container-fluid section8" data-aos="fade-up"
     data-aos-duration="3000">
      <div className="container py-5">
        <div className="bg-white vendor-wrap">
          <Slider {...settings}>
            {vendors.map((src, i) => (
              <div key={i}>
                <img loading="lazy" src={src} alt={`vendor-${i}`} className="vendor-img" />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default VendorCarousel;
